import React from "react";


const EditIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.498" viewBox="0 0 19.5 19.498">
            <path id="Content-Paper-Edit--Streamline-Ultimate" d="M6.745,16.348h-4.8a1.2,1.2,0,0,1-1.2-1.2V1.95a1.2,1.2,0,0,1,1.2-1.2h12a1.2,1.2,0,0,1,1.2,1.2v5.4m-8.4-3h4.8m-7.2,3.6h7.2m-7.2,3.6h6m7.9.5-6.1,6.1-3,.6.6-3,6.1-6.1a1.69,1.69,0,0,1,2.393,0l.007.006a1.693,1.693,0,0,1,0,2.393Z" transform="translate(0.004)" fill="none" stroke="rgba(23,41,81,0.7)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
        </svg>

    );

}

export default EditIcon;